import React, { ReactElement } from "react";
import { FormattedMessage } from "react-intl";

import CircularProgress from "@mui/material/CircularProgress";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { ILocations } from "types/api/serversApiInterface";

import CAutoscaleAndMsize from "./CAutoscaleAndMsize";
import CCountry from "./CCountry";
import CSize from "./CSize";

const ContaboCloudbucketCreation = ({
 stepLoading,
 locationList,
 size,
 location,
 autoscaling,
 max_size,
 resetData,
 handleOpen,
 setData
}: {
 stepLoading: boolean;
 locationList: Array<ILocations>;
 size: number;
 location: number;
 autoscaling: boolean;
 max_size: number;
 resetData: () => void;
 handleOpen: () => void;
 setData: (section: string, value: string | number | boolean | ILocations) => void;
}): ReactElement => {
 return !stepLoading ? (
  <Stack mt={2} spacing={2}>
   <CCountry
    locationList={locationList}
    location={location}
    setData={(section, value) => setData(section, value)}
   />
   <CSize size={size} setData={(section, value) => setData(section, value)} />
   <CAutoscaleAndMsize
    size={size}
    autoscaling={autoscaling}
    max_size={max_size}
    disableNext={location === 0 || size === 0}
    resetData={resetData}
    handleOpen={handleOpen}
    setData={(section, value) => setData(section, value)}
   />
  </Stack>
 ) : (
  <Paper elevation={1} sx={{ borderRadius: "5px", p: 2, textAlign: "left", mt: 2 }}>
   <Stack spacing={2} direction="row" alignItems="center">
    <Typography variant="subtitle2">
     <FormattedMessage id="server.checkExecution" />
    </Typography>
    <CircularProgress />
   </Stack>
  </Paper>
 );
};

export default ContaboCloudbucketCreation;
